import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { BASE_URL } from "../../services/config";
import { useAuth, authStore } from "../../store/authStore";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [mobileCatId, setMobileCatId] = useState("");
  const { isLoggedIn, customer } = useAuth();
  const nav = useNavigate();

  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", h);

    fetch(`${BASE_URL}/categories`)
      .then(r => r.json())
      .then(data => {
        const cats = data.categories || [];
        const m = cats.find((c: any) => c.name.toLowerCase().includes("phone") || c.name.toLowerCase().includes("mobile"));
        if (m) setMobileCatId(m._id);
        else if (cats.length > 0) setMobileCatId(cats[0]._id);
      })
      .catch(console.error);

    return () => window.removeEventListener("scroll", h);
  }, []);

  const sellTo = mobileCatId ? `/category/${mobileCatId}` : "/";

  return (
    <header style={{ position: "sticky", top: 0, zIndex: 100 }}>
      {/* Top bar */}
      <div className="top-bar hide-mobile" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div style={{ maxWidth: 1160, width: "100%", margin: "0 auto", padding: "0 20px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <a href="tel:+918800880101" style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ fontSize: 12 }}>📞</span>
              <span>8800880101</span>
            </a>
            <span style={{ color: "rgba(255,255,255,0.2)" }}>|</span>
            <a href="mailto:info@truevaluemobiles.in" style={{ display: "flex", alignItems: "center", gap: 5 }}>
              <span style={{ fontSize: 12 }}>✉️</span>
              <span>info@truevaluemobiles.in</span>
            </a>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            {isLoggedIn && (
              <Link to="/my-orders" style={{ fontSize: 12, color: "rgba(255,255,255,0.7)", transition: "color 0.2s" }}
                onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
                onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.7)")}>
                My Orders
              </Link>
            )}
            <a href="https://www.facebook.com/" target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>Facebook</a>
            <a href="https://www.instagram.com/" target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>Instagram</a>
            <a href="https://twitter.com/" target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>Twitter</a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav style={{
        backdropFilter: "blur(16px)", WebkitBackdropFilter: "blur(16px)",
        borderBottom: "1px solid var(--border)",
        background: scrolled ? "rgba(247,248,252,0.97)" : "rgba(247,248,252,0.92)",
        transition: "background 0.3s",
        paddingTop: "env(safe-area-inset-top)",
      }}>
        <div style={{ maxWidth: 1160, margin: "0 auto", padding: "0 20px", height: 64, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16 }}>
          {/* Logo */}
          <Link to="/" style={{ display: "flex", alignItems: "center", textDecoration: "none", flexShrink: 0 }}>
            <img src="/finalogo.png" alt="True Value Mobiles" className="header-logo" style={{ height: 52, width: "auto", display: "block", maxWidth: "100%" }} />
          </Link>

          {/* Desktop nav */}
          <nav style={{ display: "flex", alignItems: "center", gap: 28 }} className="hide-mobile">
            {[
              { to: "/", label: "Home" },
              { to: sellTo, label: "Sell Phone" },
              { to: "/how-it-works", label: "How It Works" },
              { to: "/contact", label: "Contact" },
              ...(isLoggedIn ? [{ to: "/my-orders", label: "My Orders" }] : []),
            ].map(n => (
              <Link key={n.label} to={n.to} style={{ fontSize: 14, fontWeight: 600, color: "var(--text2)", textDecoration: "none", transition: "color 0.2s", position: "relative" }}
                onMouseEnter={e => (e.currentTarget.style.color = "var(--brand)")}
                onMouseLeave={e => (e.currentTarget.style.color = "var(--text2)")}>
                {n.label}
              </Link>
            ))}
          </nav>

          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            {/* Sell Now CTA */}
            <Link to={sellTo} className="hide-mobile" style={{
              background: "linear-gradient(135deg, var(--brand), var(--brand-dark))",
              color: "#fff", borderRadius: 10, padding: "10px 22px", fontSize: 14, fontWeight: 700,
              fontFamily: "var(--font-display)", textDecoration: "none",
              boxShadow: "0 4px 14px rgba(255,107,53,0.35)", transition: "all 0.2s", whiteSpace: "nowrap",
            }}
              onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.transform = "translateY(-1px)"; el.style.boxShadow = "0 6px 20px rgba(255,107,53,0.45)"; }}
              onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.transform = ""; el.style.boxShadow = "0 4px 14px rgba(255,107,53,0.35)"; }}>
              Sell Now
            </Link>

            {/* Desktop auth */}
            {isLoggedIn ? (
              <div className="hide-mobile" style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{
                  display: "flex", alignItems: "center", gap: 8,
                  background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 10,
                  padding: "7px 14px", fontSize: 13, fontWeight: 600, color: "var(--text)",
                }}>
                  <div style={{
                    width: 26, height: 26, borderRadius: 7, background: "var(--brand-light)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 12, fontWeight: 700, color: "var(--brand)",
                  }}>
                    {customer?.name ? customer.name.charAt(0).toUpperCase() : (customer?.phone ? customer.phone.slice(-2) : "👤")}
                  </div>
                  <span>{customer?.name || (customer?.phone ? `+91 ${customer.phone}` : "Account")}</span>
                </div>
                <button onClick={() => authStore.logout()} style={{
                  background: "none", border: "1.5px solid var(--border)", borderRadius: 10,
                  padding: "7px 14px", fontSize: 13, fontWeight: 600, color: "var(--text2)",
                  cursor: "pointer", fontFamily: "var(--font-body)", transition: "all 0.2s",
                }}
                  onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "var(--danger)"; el.style.color = "var(--danger)"; }}
                  onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "var(--border)"; el.style.color = "var(--text2)"; }}>
                  Logout
                </button>
              </div>
            ) : (
              <Link to="/login" className="hide-mobile" style={{
                display: "flex", alignItems: "center", gap: 6,
                background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 10,
                padding: "8px 16px", fontSize: 14, fontWeight: 600, color: "var(--text)",
                textDecoration: "none", transition: "all 0.2s",
              }}
                onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "var(--brand)"; el.style.color = "var(--brand)"; }}
                onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.borderColor = "var(--border)"; el.style.color = "var(--text)"; }}>
                Login
              </Link>
            )}

            {/* User icon on mobile */}
            {isLoggedIn ? (
              <button className="hide-desktop" onClick={() => setMenuOpen(o => !o)} style={{
                width: 38, height: 38, borderRadius: 9, border: "1.5px solid var(--brand)",
                background: "var(--brand-light)", display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", padding: 0,
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--brand)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
            ) : (
              <button className="hide-desktop" onClick={() => nav("/login")} style={{
                width: 38, height: 38, borderRadius: 9, border: "1.5px solid var(--border)",
                background: "var(--surface)", display: "flex", alignItems: "center", justifyContent: "center",
                cursor: "pointer", padding: 0,
              }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="var(--text2)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                  <circle cx="12" cy="7" r="4" />
                </svg>
              </button>
            )}

            {/* Hamburger */}
            <button className="hide-desktop hamburger" onClick={() => setMenuOpen(o => !o)}
              style={{ width: 38, height: 38, borderRadius: 9, border: "1px solid var(--border)", background: "var(--surface)", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 5, cursor: "pointer", padding: 0 }}>
              {menuOpen
                ? <span style={{ fontSize: 18, color: "var(--text)" }}>✕</span>
                : [0, 1, 2].map(i => <span key={i} style={{ width: 18, height: 2, background: "var(--text)", borderRadius: 2, display: "block" }} />)}
            </button>
          </div>
        </div>

        {/* Mobile dropdown */}
        {menuOpen && (
          <div className="mobile-menu animate-fade-in">
            <div style={{ borderRadius: 16, overflow: "hidden", border: "1px solid var(--border)", background: "var(--surface)" }}>
              {[
                { to: "/", label: "Home", icon: "🏠" },
                { to: sellTo, label: "Sell Phone", icon: "📱", badge: "Best Price" },
                { to: "/how-it-works", label: "How It Works", icon: "🔍" },
                { to: "/contact", label: "Contact", icon: "📞" },
                ...(isLoggedIn ? [
                  { to: "/my-orders", label: "My Orders", icon: "📦" },
                ] : []),
              ].map((n, i, arr) => (
                <Link key={n.label} to={n.to} onClick={() => setMenuOpen(false)}
                  style={{ display: "flex", alignItems: "center", gap: 12, padding: "15px 16px", fontSize: 15, fontWeight: 600, color: "var(--text)", textDecoration: "none", borderBottom: i < arr.length - 1 ? "1px solid var(--border)" : "none", background: "transparent" }}
                  onMouseEnter={e => (e.currentTarget.style.background = "var(--surface2)")}
                  onMouseLeave={e => (e.currentTarget.style.background = "transparent")}>
                  <span style={{ fontSize: 18, width: 24, textAlign: "center" }}>{n.icon}</span>
                  <span style={{ flex: 1 }}>{n.label}</span>
                  {n.badge && (
                    <span style={{ fontSize: 10, fontWeight: 700, color: "var(--brand)", background: "var(--brand-light)", border: "1px solid rgba(255,107,53,0.22)", padding: "2px 8px", borderRadius: 99 }}>{n.badge}</span>
                  )}
                  <span style={{ color: "var(--text3)", fontWeight: 500 }}>›</span>
                </Link>
              ))}
            </div>

            {/* Mobile auth */}
            {isLoggedIn ? (
              <div style={{ marginTop: 10, borderRadius: 16, overflow: "hidden", border: "1px solid var(--border)", background: "var(--surface)" }}>
                <div style={{ display: "flex", alignItems: "center", gap: 10, padding: "14px 16px", borderBottom: "1px solid var(--border)" }}>
                  <div style={{
                    width: 32, height: 32, borderRadius: 8, background: "var(--brand-light)",
                    display: "flex", alignItems: "center", justifyContent: "center",
                    fontSize: 13, fontWeight: 700, color: "var(--brand)",
                  }}>
                    {customer?.name ? customer.name.charAt(0).toUpperCase() : (customer?.phone ? customer.phone.slice(-2) : "👤")}
                  </div>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 600, color: "var(--text)" }}>
                      {customer?.name || (customer?.phone ? `+91 ${customer.phone}` : "Account")}
                    </div>
                    {customer?.name && customer?.phone && (
                      <div style={{ fontSize: 11, color: "var(--text3)" }}>+91 {customer.phone}</div>
                    )}
                    <div style={{ fontSize: 11, color: "var(--text3)" }}>Logged in</div>
                  </div>
                </div>
                <button onClick={() => { authStore.logout(); setMenuOpen(false); }}
                  style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "14px 16px", fontSize: 15, fontWeight: 600, color: "var(--danger)", background: "transparent", border: "none", cursor: "pointer", fontFamily: "var(--font-body)" }}
                  onMouseEnter={e => (e.currentTarget.style.background = "var(--surface2)")}
                  onMouseLeave={e => (e.currentTarget.style.background = "transparent")}>
                  <span style={{ fontSize: 18, width: 24, textAlign: "center" }}>🚪</span>
                  <span>Logout</span>
                </button>
              </div>
            ) : (
              <Link to="/login" onClick={() => setMenuOpen(false)} style={{
                marginTop: 10, display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
                background: "var(--surface)", border: "1.5px solid var(--border)", borderRadius: 12,
                padding: "14px", fontSize: 15, fontWeight: 700, fontFamily: "var(--font-display)",
                color: "var(--text)", textDecoration: "none",
              }}>
                Login / Sign Up
              </Link>
            )}

            <Link to={sellTo} onClick={() => setMenuOpen(false)} className="mobile-cta-btn"
              style={{ marginTop: 10, display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: "var(--brand)", color: "#fff", borderRadius: 12, padding: "14px", fontSize: 15, fontWeight: 700, fontFamily: "var(--font-display)", textDecoration: "none", boxShadow: "var(--shadow-glow)" }}>
              Sell Now →
            </Link>
          </div>
        )}
      </nav>
    </header>
  );
}

export function Footer() {
  const [cats, setCats] = useState<any[]>([]);
  const [brands, setBrands] = useState<any[]>([]);
  const [mobileCatId, setMobileCatId] = useState("");
  const { isLoggedIn } = useAuth();

  useEffect(() => {
    fetch(`${BASE_URL}/categories`)
      .then(r => r.json())
      .then(data => {
        const c = data.categories || [];
        setCats(c);
        const m = c.find((x: any) => x.name.toLowerCase().includes("phone") || x.name.toLowerCase().includes("mobile"));
        if (m) setMobileCatId(m._id);
        else if (c.length > 0) setMobileCatId(c[0]._id);
      })
      .catch(console.error);
    fetch(`${BASE_URL}/nodes?parentId=null`)
      .then(r => r.json())
      .then(data => setBrands(data.nodes || []))
      .catch(console.error);
  }, []);

  const sellTo = mobileCatId ? `/category/${mobileCatId}` : "/";

  return (
    <footer style={{ background: "#111827" }}>
      <div style={{ height: 3, background: "linear-gradient(90deg, #ff6b35, #f59e0b, #4f46e5)" }} />

      <div className="footer-grid" style={{
        maxWidth: 1160, margin: "0 auto", padding: "52px 20px 36px",
        display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1.2fr", gap: 36,
      }}>
        {/* Brand column */}
        <div>
          <Link to="/" style={{ display: "flex", alignItems: "center", marginBottom: 14 }}>
            <img src="/finalogo.png" alt="True Value Mobiles" style={{ height: 34, width: "auto", display: "block", background: "#fff", borderRadius: 8, padding: "4px 10px" }} />
          </Link>
          <p style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", lineHeight: 1.7, maxWidth: 260, marginBottom: 16 }}>
            We buy, sell and repair used phones at the best price. Instant cash, free pickup, zero hassle.
          </p>
          <div style={{ display: "flex", flexDirection: "column", gap: 6, fontSize: 13, color: "rgba(255,255,255,0.45)" }}>
            <a href="tel:+918800880101" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", transition: "color 0.2s" }}
              onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
              onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
              📞 8800880101
            </a>
            <a href="mailto:info@truevaluemobiles.in" style={{ color: "rgba(255,255,255,0.55)", textDecoration: "none", transition: "color 0.2s" }}
              onMouseEnter={e => (e.currentTarget.style.color = "#fff")}
              onMouseLeave={e => (e.currentTarget.style.color = "rgba(255,255,255,0.55)")}>
              ✉️ info@truevaluemobiles.in
            </a>
          </div>
        </div>

        {/* Quick Links */}
        <div>
          <h4 className="footer-heading">Quick Links</h4>
          <ul style={{ listStyle: "none", display: "flex", flexDirection: "column" }}>
            {[
              { label: "About Us", to: "/" },
              { label: "How It Works", to: "/how-it-works" },
              { label: "Contact Us", to: "/contact" },
              { label: "Privacy Policy", to: "/privacy-policy" },
              { label: "Terms of Service", to: "/terms" },
            ].map(l => (
              <li key={l.label}>
                <Link to={l.to} className="footer-link">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Our Services */}
        <div>
          <h4 className="footer-heading">Our Services</h4>
          <ul style={{ listStyle: "none", display: "flex", flexDirection: "column" }}>
            {[
              { label: "Sell Your Phone", to: sellTo },
              { label: "How It Works", to: "/how-it-works" },
              ...(isLoggedIn ? [{ label: "My Orders", to: "/my-orders" }] : []),
              ...(!isLoggedIn ? [{ label: "Login / Sign Up", to: "/login" }] : []),
            ].map(l => (
              <li key={l.label}>
                <Link to={l.to} className="footer-link">{l.label}</Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Popular Brands */}
        <div>
          <h4 className="footer-heading">Popular Brands</h4>
          <ul style={{ listStyle: "none", display: "flex", flexDirection: "column" }}>
            {brands.slice(0, 8).map(b => (
              <li key={b._id}>
                <Link to={`/brand/${b._id}`} className="footer-link">{b.name}</Link>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div style={{ borderTop: "1px solid rgba(255,255,255,0.07)", padding: "18px 20px", display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 12 }}>
        <span style={{ fontSize: 12, color: "rgba(255,255,255,0.28)" }}>© 2026 True Value Mobiles — All rights reserved.</span>
        <span style={{ fontSize: 12, color: "rgba(255,255,255,0.28)" }}>Made with ♥ in India</span>
      </div>
    </footer>
  );
}
